module.exports = __webpack_public_path__ + "img/phone.ea9fbcdb.png";